import { render, staticRenderFns } from "./WalletDetails.vue?vue&type=template&id=e057f85a&scoped=true&"
import script from "./WalletDetails.vue?vue&type=script&lang=js&"
export * from "./WalletDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e057f85a",
  null
  
)

export default component.exports